import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormControl,
  Validators
} from '@angular/forms';
import {
  MatSnackBar
} from '@angular/material/snack-bar';
import {
  Router
} from '@angular/router';
import {
  ApiService
} from 'src/app/services/api/api.service';
import {
  GlobalsService
} from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-resetpass',
  templateUrl: './resetpass.component.html',
  styleUrls: ['./resetpass.component.scss']
})
export class ResetpassComponent implements OnInit {

  constructor(public globals: GlobalsService, private api: ApiService, private router: Router, private _snackBar: MatSnackBar) {}

  emailFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  passwordFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);

  passwordRetypeFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(this.passwordFormControl.value)
  ]);

  public hide: boolean = false

  public hidePW1: boolean = true;
  public hidePW3: boolean = true;
  public hidePW2: boolean = true;

  ngOnInit(): void {


  }

  resetPassword() {

    //Get passwords

    //Validate
    if (this.passwordFormControl.value && this.passwordFormControl.value != "" && this.passwordRetypeFormControl.value && this.passwordRetypeFormControl.value != "" && this.passwordRetypeFormControl.value == this.passwordFormControl.value) {

      // this.emailFormControl.value
      this.api.resetPassword(this.passwordFormControl.value, (res: any) => {

        //Route to login
        this.globals.isReset = false;
        this.globals.showGatekeeper = true;

      }, () => {

        this._snackBar.open(`Reset password failed`, "Close", {
          duration: 5000,
          panelClass: ['red-snackbar']
        });


      })
    } else {
      if (this.passwordFormControl.value != this.passwordRetypeFormControl.value) {
        this._snackBar.open(`Passwords does not match`, "Close", {
          duration: 5000,
          panelClass: ['red-snackbar']
        });
      } else {
        this._snackBar.open(`Please enter a valid password`, "Close", {
          duration: 5000,
          panelClass: ['red-snackbar']
        });
      }
    }


  }

}
